import React, { useState, useRef, useEffect } from "react";
import { BsMusicNoteBeamed, BsPersonFill } from "react-icons/bs";
import { Animate } from "react-simple-animate";
import "./styles.scss";

const naats = [
  { title: "GHAM -E- HIJR E MUSTAFA MEIN", naatKhawan: "ALHAJJ MUHAMMAD OWAIS RAZA QADRI", audioSrc: "/naat/gh.mp3" },
  { title: "Yeh Sab Tumhara Karam", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/karam.mp3" },
  { title: "Chhor Fikr Dunya Ki", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/fikr.mp3" },
  { title: "Hajion Main Naam Likh De", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/hajjj.mp3" },
  { title: "Mujhe Dar Pe Phir Bulana", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/naat_new.mp3" },
  { title: "Milad Na Chorengy", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/naat8.mp3" },

  { title: "Parho La Ilaha Illallah", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/new_naat.mp3" },
  { title: "Milad Tha Milad Hai Milad Rahy Ga", naatKhawan: "Hafiz Tahir Qadri", audioSrc: "/naat/milad.mp3" },
  { title: "Alif Se Yaad Karo ALLAH", naatKhawan: "Yasir Soharwardi", audioSrc: "/naat/alifse.mp3" },
  { title: "Main Toh Ashiq Hoon Nabi Ka", naatKhawan: "Farhan Ali Qadri", audioSrc: "/naat/naat7.mp3" },

  { title: "Ya Rab Meri Soi Hui Taqdeer", naatKhawan: "Farhan Ali Qadri", audioSrc: "/naat/soi.mp3" },
  { title: "Ya Mustufa", naatKhawan: "Farhan Ali Qadri", audioSrc: "/naat/ya.mp3" },
  { title: "Allah Hoo Allah Hoo", naatKhawan: "Farhan Ali Qadri", audioSrc: "/naat/fq.mp3" },
  { title: "Sirf Aik Baaar Dil Se Mustufa Ko Pukar", naatKhawan: "Farhan Ali Qadri", audioSrc: "/naat/sirf.mp3" },
];

const videos = [
  { title: "Pahonchoon Dar-e-Sarkar", videoSrc: "/naat/v1.mp4" },
  { title: "Har Haaal Mai Sarkar Ka Milad Karenge", videoSrc: "/naat/sarkarkamilad.mp4" },
  { title: "Dekhte Kya Ho Ahle Safa", videoSrc: "/naat/v2.mp4" },
  { title: "Ek Bar Ya Muhammad", videoSrc: "/naat/ekbar.mp4" },
  { title: "Sahara Chahiye Sarkar", videoSrc: "/naat/v3.mp4" },
  { title: "Chahat Rasool Ki", videoSrc: "/naat/c.mp4" },
  { title: "Subha Taiba Mein Hui", videoSrc: "/naat/v4.mp4" },
  { title: "Na Koi Aap Jaisa Hoga Na Koi Aap Jaisa Tha", videoSrc: "/naat/latest.mp4" },
  { title: "Mehsoos Karraha Hu Duniya Hai Ek Dhoka", videoSrc: "/naat/v5.mp4" },
  { title: "Ramzan Asalam", videoSrc: "/naat/r.mp4" },
  { title: "Shaan -e- Ramzan", videoSrc: "/naat/sr.mp4" },
  { title: "Tere Bande Hain Hum", videoSrc: "/naat/tbhh.mp4" },
  { title: "Unka Naam Labo pr aye", videoSrc: "/naat/kids_naat.mp4" },
];

const VideoThumbnail = ({ videoSrc, onEnded, isPlaying, setIsPlaying, autoPlayVideo }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isPlaying && autoPlayVideo && videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play().catch((err) => {
        console.log("Autoplay error:", err);
      });
    }
  }, [isPlaying, autoPlayVideo]);

  return (
    <div className="video-wrapper">
      {!isPlaying ? (
        <video
          src={videoSrc}
          onClick={setIsPlaying}
          style={{
            cursor: "pointer",
            width: "100%",
            height: "200px",
            objectFit: "cover",
            borderRadius: "10px",
          }}
          muted
          preload="metadata"
        />
      ) : (
        <video
          ref={videoRef}
          controls
          onEnded={onEnded}
          className="naat-video"
          style={{ width: "100%", borderRadius: "10px" }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};


const Naat = () => {
  const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
  const [autoPlayAudio, setAutoPlayAudio] = useState(false);
  const audioRef = useRef(null);

  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [autoPlayVideo, setAutoPlayVideo] = useState(false);
  const [playingVideoIndex, setPlayingVideoIndex] = useState(null);

  useEffect(() => {
    if (autoPlayAudio && audioRef.current) {
      audioRef.current.play();
    }
  }, [currentAudioIndex, autoPlayAudio]);

  const handleAudioEnded = () => {
    if (autoPlayAudio && currentAudioIndex < naats.length - 1) {
      setCurrentAudioIndex(currentAudioIndex + 1);
    }
  };
  const handleVideoEnded = () => {
    if (autoPlayVideo) {
      setCurrentVideoIndex((prevIndex) => {
        if (prevIndex < videos.length - 1) {
          setPlayingVideoIndex(prevIndex + 1);
          return prevIndex + 1;
        } else {
          // Agar last video ho, autoplay off kar do
          setAutoPlayVideo(false);
          setPlayingVideoIndex(null);
          return prevIndex;
        }
      });
    }
  };


  return (
    <section id="naat-page" className="naat-page">

      {/* Video Section */}
      <div className="video-section">
        <h2 className="section-title">Naat Videos</h2>
        <button
          className="play-all-button"
          onClick={() => {
            setAutoPlayVideo(!autoPlayVideo);
            setPlayingVideoIndex(currentVideoIndex);
          }}
        >
          {autoPlayVideo ? "Stop Video AutoPlay" : "Start Video AutoPlay"}
        </button>
        <div className="video-grid">
          {videos.map((video, index) => (
            <div key={index} className="video-container">
              <h3 className="video-title">{video.title}</h3>
              <VideoThumbnail
                videoSrc={video.videoSrc}
                onEnded={handleVideoEnded}
                isPlaying={playingVideoIndex === index}
                setIsPlaying={() => {
                  setPlayingVideoIndex(index);
                  setCurrentVideoIndex(index);
                }}
                autoPlayVideo={autoPlayVideo}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Audio Section */}
      <div className="audio-section">
        <h2 className="section-title">Naat Audios</h2>
        <button
          className="play-all-button"
          onClick={() => setAutoPlayAudio(!autoPlayAudio)}
        >
          {autoPlayAudio ? "Stop Audio AutoPlay" : "Start Audio AutoPlay"}
        </button>
        <div className="naat-grid">
          {naats.map((naat, index) => (
            <Animate
              key={index}
              play
              duration={1.5}
              delay={0.2 * index}
              start={{ opacity: 0, transform: "translateY(-20px)" }}
              end={{ opacity: 1, transform: "translateY(0px)" }}
            >
              <div className="naat-container">
                <h2 className="naat-title">
                  <BsMusicNoteBeamed size={30} /> {naat.title}
                </h2>
                <p className="naat-khawan">
                  <BsPersonFill size={20} /> {naat.naatKhawan}
                </p>
                <div className="audio-player">
                  {index === currentAudioIndex ? (
                    <audio
                      controls
                      autoPlay={autoPlayAudio}
                      ref={audioRef}
                      onEnded={handleAudioEnded}
                      onPlay={() => setCurrentAudioIndex(index)}
                    >
                      <source src={naat.audioSrc} type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                  ) : (
                    <audio
                      controls
                      onPlay={() => setCurrentAudioIndex(index)}
                    >
                      <source src={naat.audioSrc} type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                  )}
                </div>
              </div>
            </Animate>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Naat;
